import type * as React from 'react';
import { type SelectOption } from './SelectInput.tsx';
import { useSelectedOptionLabel } from './select/useSelectedOptionLabel.tsx';

export interface IStaticChipValueProps {
  value: string | string[];
  options: SelectOption[];
}

/**
 * Variante "static" di `AsyncSelectChipValue`: risolve value→label nel chip della
 * FilterBar dalle stesse `options` statiche del `SelectInput` (nessuna query).
 */
export function StaticChipValue(props: IStaticChipValueProps) {
  const { value, options } = props;

  const label = useSelectedOptionLabel(
    value,
    options,
    Array.isArray(value) ? 'multiple' : undefined,
    'label',
  );

  return label ? <>{label}</> : null;
}

/**
 * Costruisce il `renderValue` per un campo `Custom` con `SelectInput` a opzioni
 * statiche. Ritorna `null` sui valori vuoti; vedi `ui/.../filter-bar/README.md`.
 */
export function createStaticChipValue(
  options: SelectOption[],
): (value: unknown) => React.ReactNode {
  return value => {
    if (
      value == null ||
      value === '' ||
      (Array.isArray(value) && value.length === 0)
    ) {
      return null;
    }
    return (
      <StaticChipValue value={value as string | string[]} options={options} />
    );
  };
}
